import { render, staticRenderFns } from "./CuadroTexto.vue?vue&type=template&id=8d099912&scoped=true&"
import script from "./CuadroTexto.vue?vue&type=script&lang=js&"
export * from "./CuadroTexto.vue?vue&type=script&lang=js&"
import style0 from "./CuadroTexto.vue?vue&type=style&index=0&id=8d099912&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8d099912",
  null
  
)

export default component.exports